/* ==========================================================================
   ELORE — Vacation Collection
   Extracted verbatim from the inline <script id="tailwind-config"> block.

   Load order requirement (unchanged from the source document):
     1. https://cdn.tailwindcss.com?plugins=forms,container-queries
     2. this file (elore-vacation-collection.js)
     3. the page markup
   This section's .liquid file preserves that exact order.

   No keys, values, or structure changed — nothing added, nothing removed.
   ========================================================================== */

tailwind.config = {
    darkMode: "class",
    theme: {
        extend: {
            "colors": {
                "inverse-on-surface": "#f4f0e7",
                "surface-bright": "#fdf9f0",
                "surface-container-low": "#f7f3ea",
                "on-secondary-fixed": "#3f0300",
                "on-error-container": "#93000a",
                "secondary-container": "#fe7d65",
                "on-primary-fixed": "#171e0c",
                "surface-container-highest": "#e6e2d9",
                "on-tertiary-container": "#e0ab3d",
                "primary-fixed-dim": "#c2caae",
                "on-tertiary-fixed": "#271900",
                "tertiary-fixed": "#ffdea6",
                "primary": "#2b321e",
                "surface-tint": "#5a614b",
                "background": "#fdf9f0",
                "tertiary-fixed-dim": "#f5be4e",
                "on-background": "#1c1c16",
                "tertiary-container": "#5c4100",
                "on-primary": "#ffffff",
                "on-tertiary-fixed-variant": "#5d4200",
                "on-primary-fixed-variant": "#424934",
                "secondary-fixed-dim": "#ffb4a6",
                "primary-fixed": "#dee6c9",
                "on-secondary-fixed-variant": "#842414",
                "surface-container-lowest": "#ffffff",
                "outline": "#76786f",
                "on-primary-container": "#afb69c",
                "on-secondary-container": "#711608",
                "on-error": "#ffffff",
                "surface-variant": "#e6e2d9",
                "on-tertiary": "#ffffff",
                "inverse-primary": "#c2caae",
                "outline-variant": "#c7c7bd",
                "error": "#ba1a1a",
                "on-surface-variant": "#46483f",
                "secondary-fixed": "#ffdad3",
                "on-surface": "#1c1c16",
                "error-container": "#ffdad6",
                "primary-container": "#414833",
                "surface-dim": "#dddad1",
                "secondary": "#a53b29",
                "surface-container-high": "#ece8df",
                "surface-container": "#f1eee5",
                "on-secondary": "#ffffff",
                "tertiary": "#402c00",
                "surface": "#fdf9f0",
                "inverse-surface": "#31302b"
            },
            "borderRadius": {
                "DEFAULT": "0.25rem",
                "lg": "0.5rem",
                "xl": "0.75rem",
                "full": "9999px"
            },
            "spacing": {
                "section-gap-desktop": "120px",
                "gutter": "24px",
                "editorial-inset": "10%",
                "section-gap-mobile": "64px",
                "unit": "8px"
            },
            "fontFamily": {
                "label-caps": ["Montserrat"],
                "display-lg-mobile": ["Michelia"],
                "body-lg": ["Montserrat"],
                "script-accent": ["Romantic Couple"],
                "body-sm": ["Montserrat"],
                "headline-md": ["Montserrat"],
                "display-lg": ["Michelia"]
            },
            "fontSize": {
                "label-caps": ["12px", { "lineHeight": "1", "letterSpacing": "0.1em", "fontWeight": "600" }],
                "display-lg-mobile": ["36px", { "lineHeight": "1.2", "fontWeight": "400" }],
                "body-lg": ["16px", { "lineHeight": "1.6", "fontWeight": "400" }],
                "script-accent": ["30px", { "lineHeight": "1", "fontWeight": "400" }],
                "body-sm": ["14px", { "lineHeight": "1.6", "fontWeight": "400" }],
                "headline-md": ["22px", { "lineHeight": "1.4", "letterSpacing": "0.05em", "fontWeight": "500" }],
                "display-lg": ["48px", { "lineHeight": "1.1", "letterSpacing": "-0.02em", "fontWeight": "400" }]
            }
        }
    }
}
function initHeaderScrollEffect(root) {
  var header = root.querySelector("#top-nav");
  if (!header) return function () {};

  function onScroll() {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", onScroll);

  return function destroy() {
    window.removeEventListener("scroll", onScroll);
  };
}
